<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2 p-0 m-0">
            <bita-bootbutton
              type="primary"
              title="افزودن سطح دسترسی"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="createPermission"
            />
          </div>
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-permissions="permission"
      :props-data="editForm"
      modal-id="edit-modal"
      title="ویرایش سطح دسترسی"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :props-data="editForm"
      :props-permissions="permission"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن سطح دسترسی"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import RoleForm from "./Form";
export default {
  components: { "form-modal": RoleForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت سطح دسترسی",
          link: "/management/roles",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      role: {
        name: "",
        permissions: [],
      },
      permission: {},
      editForm: { asfas: "asfasf" },
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام سطح دسترسی", width: "100px" },
        { field: "fa_name", title: "نام فارسی سطح دسترسی", width: "100px" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: "100px",
        },
        {
          title: "عملیات",
          command: [],
          width: "100px",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  methods: {
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      this.$persistClient("get", "permissions")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    save() {
      this.$refs.test.validate().then((result) => {
        if (result) {
          this.isLoadingForm = true;
          this.$persistClient("post", "permissions", this.role)
            .then((res) => {
              this.$izitoast(
                "success",
                "عملیات موفق",
                "سطح دسترسی مورد نظر ایجاد شد"
              );
              this.role = {
                name: "",
                permissions: [],
              };
              this.$refs.test.reset();
            })
            .finally(() => {
              this.isLoadingForm = false;
            });
        }
      });
    },
    edit(e) {
      this.isLoadingModal = true;
      const _this = this;
      this.editForm = this.$refs.grid.getSelectedGridRow(e);
      setTimeout(function() {
        _this.isLoadingModal = false;
      }, 500);
      this.statusChangeModalEdit();
    },
    delete(e) {
      let role = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${role.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `permissions/${role.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createPermission() {
      this.editForm = {};
      this.statusChangeModalCreate();
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
        fa_name: e.fa_name,
      };
      this.$persistClient("patch", `permissions/${e.id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
          this.loadData();
        });
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        name: e.name,
        fa_name: e.fa_name,
      };
      this.$persistClient("post", "permissions", data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalCreate();
          this.loadData();
        });
    },
  },
};
</script>
